import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6 dot-grid">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-8" data-testid="back-home">
          <div className="w-10 h-10 bg-[#FF4F00] border-2 border-black flex items-center justify-center font-display font-black text-white">V</div>
          <span className="font-display font-black text-2xl tracking-tight">VIBELEAD</span>
        </Link>
        <div className="card-brutal !p-8 bg-white">
          <h1 className="font-display font-black text-3xl mb-2">Welcome back</h1>
          <p className="text-zinc-600 text-sm mb-6">Log in to keep capturing leads.</p>

          <button onClick={handleGoogle} className="w-full btn-brutal-outline mb-5" data-testid="google-login-btn">
            <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/><path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/><path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/><path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/></svg>
            Continue with Google
          </button>

          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-zinc-300" />
            <span className="text-xs text-zinc-500 font-bold">OR</span>
            <div className="flex-1 h-px bg-zinc-300" />
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label-cap block mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-brutal" placeholder="you@company.com" data-testid="login-email-input" />
            </div>
            <div>
              <label className="label-cap block mb-2">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-brutal" placeholder="••••••••" data-testid="login-password-input" />
            </div>
            <button type="submit" disabled={loading} className="w-full btn-brutal" data-testid="login-submit-btn">
              {loading ? "Logging in…" : "Log in"}
            </button>
          </form>

          <p className="text-sm text-zinc-600 mt-5 text-center">
            New here? <Link to="/signup" className="font-bold underline" data-testid="goto-signup">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
